import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import * as React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

const PREFIX = "HelpButton";

const classes = {
  buttonStyle: `${PREFIX}-buttonStyle`,
};

const StyledButton = styled(Button)(({ theme }) => ({
  [`&.${classes.buttonStyle}`]: {
    "float": "right",
    "border": "1px solid #ACC8DF",
    "borderRadius": "3px",
    "padding": "6px 16px 6px 16px",
    "height": 32,
    "textAlign": "left",
    "backgroundColor": "#d9e8f6",
    "color": theme.palette.primary.main,

    "& .MuiSvgIcon-root": {
      marginLeft: 5,
      color: "#1A4480",
    },

    "&:hover, &:focus": {
      "color": "white",
      "backgroundColor": "#1A4480",
      "border": "1px solid #1A4480",
      "& .MuiSvgIcon-root": {
        color: "white",
        background: "none",
      },
    },
  },
}));

export default function HelpButton(appName: any) {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <StyledButton
      color="secondary"
      disableElevation
      className={classes.buttonStyle}
      aria-label={`View help for BankFind.`}
      id={`view-help-link-BankFind`}
      onClick={() =>
        navigate(
          {
            pathname: `/help`,
          },
          {
            state: {
              url: location.pathname + location.search,
            },
          },
        )
      }
    >
      Help
      <HelpOutlineIcon style={{ marginLeft: 5, zIndex: 100 }} />
    </StyledButton>
  );
}
